<template>
  <div>
    <!--ENVIAR ARQUIVOS POR EMAIL-->
    <ed-modal :title="'ENVIAR ARQUIVOS POR EMAIL'" :modal="showEnviarEmail" :onSave="enviar" saveName="Enviar Agora" saveIcon="fa fa-paper-plane" width="70%">
      <div slot="modal-content" v-loading="loadingEmailSave">
        <ed-alert
          type="warning"
          class="mb-4"
          description="Você pode conferir abaixo os ASO`s que serão enviados por email. Nesse etapa você pode alterar o destinatário e customizar uma mensagem para cada empresa. Clique no nome da empresa para visualizar os arquivos e customizar os dados para envio do email."
          title="Atenção"
        />

        <el-collapse accordion>
          <el-form label-position="top" label-width="100px" :model="formData" ref="ruleForm">
            <el-collapse-item :name="i" v-for="(item, i) in tableDataEmail" :key="i">
              <template slot="title">
                <span v-if="item[0] && item[0].empresa" style="color: #3777a2">
                  <b>
                    <i class="fa fa-arrow-circle-right"></i>
                    {{ item[0].empresa.nome }}
                    <span style="font-size: 10px; color: #666"> {{ formData[item[0].empresa.id].consultas.length }} aso selecionado(s) </span>

                    <span style="font-size: 10px; color: #d16868; text-align: right" v-if="formData[item[0].empresa.id].error">
                      <i class="fa fa-info-circle faa-flash animated" />
                      {{ formData[item[0].empresa.id].error }}
                    </span>
                  </b>
                </span>
              </template>

              <div class="row">
                <div class="col-md-12">
                  <el-form-item label="Destinatário" prop="destinatario" :rules="[{ required: false, message: 'Campo Obrigatorio' }]">
                    <el-input placeholder="Digite o destinatário (separado por `;` ponto e vírgula)" v-model="formData[item[0].empresa.id].destinatario"></el-input>
                  </el-form-item>
                </div>

                <div class="col-md-12">
                  <el-form-item label="Observações" prop="obs" :rules="[{ required: false, message: 'Campo Obrigatorio' }]">
                    <el-input type="textarea" placeholder="O conteúdo deste campo será anexado junto com o email enviado para o destinatário..." v-model="formData[item[0].empresa.id].obs"></el-input>
                  </el-form-item>
                </div>

                <div class="col-md-12">
                  <el-form-item label="Consultas (ASO)" prop="consultas" :rules="[{ required: false, message: 'Campo Obrigatorio' }]">
                    <table class="table table-hover has-gutter" width="100%">
                      <thead>
                        <tr>
                          <th width="120" style="font-size: 12px">Consulta</th>
                          <th style="font-size: 12px">Funcionário</th>
                          <th width="200" style="font-size: 12px">Arquivo</th>
                          <th width="200" style="font-size: 12px">Enviar por Email</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(consulta, j) in item" :key="i + j">
                          <td style="font-size: 12px">{{ consulta.id_con }}</td>
                          <td style="font-size: 12px">{{ consulta.funcionario.nome }}</td>
                          <td style="font-size: 12px">
                            <Download :arquivo="consulta.arquivo" />
                          </td>
                          <td style="font-size: 12px">
                            <el-checkbox v-model="formData[item[0].empresa.id].consultas" :label="consulta.id_con" :disabled="consulta.tipo_documento && consulta.tipo_documento.id == '82' ? false : true">
                              <span v-if="formData[item[0].empresa.id].consultas.indexOf(consulta.id_con) != -1"> Sim </span>
                              <span v-else>Não</span>
                            </el-checkbox>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </el-form-item>
                </div>
              </div>
            </el-collapse-item>
          </el-form>
        </el-collapse>
      </div>
    </ed-modal>

    <!--EDITAR-->
    <ed-modal :title="'EDITAR PÁGINA' + (formDataEdit.id ? ' ' + formDataEdit.page : '')" :modal="showFormEdit" :onSave="salvar" saveName="Salvar" saveIcon="fa fa-paper-plane" width="70%">
      <div slot="modal-content">
        <ed-alert type="warning" class="mb-4" description="Aqui você pode vincular a página, do PDF, em alguma consulta. Faça isso caso a página em questão não for identificado pelo sistema ou foi identificado incorretamente." title="Atenção" />

        <ed-form :data="formDataEdit" :config="config" :response="response" :itens="formItemsEdit">
          <div slot="form-footer"></div>
        </ed-form>

        <ed-alert v-if="formDataEdit.usuario" type="success" :description="formDataEdit.usuario.usuario + ' em ' + formDataEdit.updated_at" title="Última Atualização" />
      </div>
    </ed-modal>

    <!--DETALHAMENTO DO ARQUIVO-->
    <ed-modal :title="'DETALHAMENTO DO ARQUIVO ' + (this.parent.upload_pagina && this.parent.upload_pagina.arquivo ? this.parent.upload_pagina.arquivo.name : '')" :modal="parent.showUploadPagina" width="90%">
      <div slot="modal-content">
        <el-tabs type="border-card" v-model="tagConfig">
          <el-tab-pane label="Config" name="tab-detalhe">
            <span slot="label"><i class="fa fa-th-list"></i> Detalhamento do Arquivo</span>

            <ed-table
              :onSearch="getConsultaUploadPagina"
              :onEdit="onEdit"
              :onEditAll="onArquivoEmail"
              :tableHead="tableHead"
              :tableData="tableData"
              :loadingTable="loadingTable"
              :pagination="pagination"
              editAllName="Enviar Arquivo(s) por Email"
              editAllIcon="fa fa-paper-plane"
              editAllTitle="Clique aqui para enviar emails para os registros selecionados"
            />
          </el-tab-pane>

          <el-tab-pane label="Config" name="tab-historico">
            <span slot="label">
              <i :class="'fa fa-history'"></i>
              Histórico de Envio de Emails
            </span>

            <DownloadAsoEmail :parent="this" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </ed-modal>
  </div>
</template>

<script>
import Rest from "common/rest";
import Fct from "common/fct";
import Download from "common/download";
import EdTable from "common/table";
import EdModal from "common/modal";
import EdButton from "common/button";
import EdAlert from "common/alert";
import EdForm from "common/form";
import DownloadAsoEmail from "apps/web/consulta/liberacao/_includes/download-aso-email";
import FormItemsEdit from "../_form/upload-pagina-editar";

export default {
  name: "empresa",
  components: { EdTable, EdModal, EdForm, EdButton, EdAlert, Download, DownloadAsoEmail },
  mixins: [Rest, Fct],
  props: {
    parent: {
      type: Object,
      default: null,
    },
  },
  watch: {
    "parent.showUploadPagina"() {
      this.getConsultaUploadPagina();
    },
    "parent.upload_pagina.id"() {
      this.getConsultaUploadPagina();
    },
    "formDataEdit.id_emp"() {
      this.getFuncionario();
      this.config.disabled.id_fun = this.formDataEdit.id_emp ? false : true;
    },
    "formDataEdit.id_fun"() {
      this.getConsulta();
      this.config.disabled.id_con = this.formDataEdit.id_fun ? false : true;
    },
  },
  data() {
    return {
      pagination: {},
      response: {},
      formData: {},
      formDataEdit: {
        id: 0,
        id_emp: null,
        id_fun: null,
        id_con: null,
        usuario: null,
        updated_at: null,
      },
      config: {
        click: {
          id_emp: _.debounce(this.getEmpresa, 1000),
          id_fun: _.debounce(this.getFuncionario, 1000),
          id_con: _.debounce(this.getConsulta, 1000),
        },
        loading: {
          id_emp: false,
          id_fun: false,
          id_con: false,
          save: false,
        },
        list: {
          id_emp: [],
          id_fun: [],
          id_con: [],
        },
        disabled: {
          id_fun: true,
          id_con: true,
          page: true,
        },
      },
      consulta: null,
      tagConfig: "tab-detalhe",
      tableHead: [
        {
          key: "consulta",
          sortable: true,
          show_tipo_aso: true,
          show_link_consulta: true,
          label: "Consulta",
        },
        {
          key: "empresa",
          sortable: true,
          show_fdt: true,
          show_link_empresa: true,
          label: "Empresa",
        },
        {
          key: "funcionario",
          sortable: true,
          show_funcionario_link: true,
          show_funcao: true,
          label: "Funcionário",
        },
        {
          key: "pagina",
          sortable: true,
          width: "90px",
          label: "Página",
        },
        {
          key: "arquivo",
          sortable: true,
          show_arquivo: true,
          label: "Arquivo",
        },
        {
          key: "status",
          sortable: true,
          show_status: true,
          label: "Status",
        },
      ],
      tableData: [],
      tableDataEmail: [],
      formItemsEdit: [],
      loadingTable: false,
      showEnviarEmail: false,
      showFormEdit: false,
      showDownloadASO: false,
      loadingEmailSave: false,
    };
  },

  created() {},

  mounted: function () {
    this.formItemsEdit = FormItemsEdit;
    this.getEmpresa();
  },

  methods: {
    onArquivoEmail(item) {
      var data = [],
        tableDataEmail = {},
        formData = {};

      if (item && item.id) {
        data.push(item);
      } else {
        data = item;

        try {
          data = data.sort((a, b) => (a.empresa.nome > b.empresa.nome ? 1 : b.empresa.nome > a.empresa.nome ? -1 : 0));
        } catch (error) {
          data = item;
        }
      }

      this.showEnviarEmail = !this.showEnviarEmail;

      for (let i = 0; i < data.length; i++) {
        const element = data[i];

        if (!element.id_con) continue;

        if (!tableDataEmail[element.empresa.nome]) {
          tableDataEmail[element.empresa.nome] = [];
          formData[element.empresa.id] = {
            destinatario: element.empresa.email,
            consultas: [],
            obs: null,
            error: null,
          };
        }

        if (element.tipo_documento && element.tipo_documento.id == "82") {
          formData[element.empresa.id].consultas.push(element.id_con);
        }

        tableDataEmail[element.empresa.nome].push(element);
      }

      this.tableDataEmail = tableDataEmail;
      this.formData = formData;
    },

    onEdit(data) {
      this.formDataEdit = {
        id: data.id,
        page: data.page,
        id_emp: data.empresa ? data.empresa.id : null,
        id_fun: data.funcionario ? data.funcionario.id : null,
        id_con: data.id_con,
        usuario: data.usuario,
        updated_at: this.toDate(data.updated_at),
      };

      if (data.empresa) {
        this.config.list.id_emp = [data.empresa];
      }

      if (data.funcionario) {
        this.getFuncionario(data.funcionario.nome);
      }

      if (data.id_con) {
        this.getConsulta();
      }

      this.showFormEdit = !this.showFormEdit;
    },

    getEmpresa(_search) {
      this.config.loading.id_emp = true;
      this.config.list.id_emp = [];

      this.get("empresa", { search: _search }).then((result) => {
        result = result[0];

        this.config.loading.id_emp = false;

        if (result.status == 200) {
          this.config.list.id_emp = result.data.data;
        }
      });
    },

    getFuncionario(_search) {
      if (!this.formDataEdit.id_emp) return;

      this.config.loading.id_fun = true;
      this.config.list.id_fun = [];

      this.get("/empresa/funcionario/" + this.formDataEdit.id_emp, { search: _search, pagination: 500 }).then((result) => {
        result = result[0];

        this.config.loading.id_fun = false;

        if (result.status == 200) {
          this.config.list.id_fun = result.data.data;
        }
      });
    },

    getConsulta(_search) {
      if (!this.formDataEdit.id_emp || !this.formDataEdit.id_fun) return;

      this.config.loading.id_con = true;
      this.config.list.id_con = [];

      var filter = {
        id_empresa: this.formDataEdit.id_emp,
        id_funcionario: this.formDataEdit.id_fun,
      };

      this.get("empresa/consulta", { search: _search, filter: filter, pagination: 500 }).then((result) => {
        result = result[0];

        this.config.loading.id_con = false;

        if (result.status == 200) {
          this.config.list.id_con = result.data.data;
        }
      });
    },

    getConsultaUploadPagina(_search, _page, _pagination) {
      if (!this.parent.upload_pagina) return;

      this.loadingTable = true;

      var filter = {
        id_tipo_email: [197],
        show_emp_email: 1,
      };

      this.get("empresa/consulta/upload/pagina/" + this.parent.upload_pagina.id, { search: _search, page: _page, pagination: _pagination, filter: filter }).then((result) => {
        result = result[0];

        if (result.status == 200) {
          this.formataData(result);
        } else {
          this.$alert(result.msg, "Atenção", {
            type: "error",
            confirmButtonText: "OK",
          });
        }
      });
    },

    formataData: function (result) {
      var data = result.data.data,
        tableData = [],
        self = this,
        pagination = result.data;

      for (var i = 0; i < data.length; i++) {
        var send_email = "";

        if (data[i].send_email_at) {
          send_email = ' <i class="fa fa-envelope" title="Último envio de email desse ASO foi em: ' + this.toDate(data[i].send_email_at) + '"/>';
        }

        var item = {
          consulta: (data[i].id_con ? data[i].id_con : "---") + (send_email ? send_email : ""),
          empresa: data[i].empresa ? data[i].empresa.nome : "---",
          funcionario: data[i].funcionario ? data[i].funcionario.nome : "---",
          arquivo: data[i].arquivo ? data[i].arquivo : "---",
          pagina: data[i].page + " de " + data[i].pages,
          status: data[i].obs ? data[i].obs : "",
          _data: data[i],
          options: {},
          buttons: [],
        };

        if (data[i].arquivo && data[i].tipo_status && (data[i].tipo_status.id == "79" || data[i].tipo_status.id == "193") && data[i].tipo_documento && data[i].tipo_documento.id == "82") {
          item.buttons.push({
            icon: "fa fa-paper-plane",
            color: "success",
            title: "Enviar Arquivo por email",
            click: this.onArquivoEmail,
          });
        }

        tableData.push(item);
      }

      this.pagination = pagination;
      this.tableData = tableData;
      this.loadingTable = false;
    },

    salvar() {
      this.config.loading.save = true;

      this.post("empresa/consulta/upload/pagina/" + this.parent.upload_pagina.id + "/editar", this.formDataEdit).then((result) => {
        result = result[0];

        this.config.loading.save = false;

        if (result.status == 200) {
          this.getConsultaUploadPagina();
          this.parent.getConsultaUpload();
          this.showFormEdit = !this.showFormEdit;
          this.edMsg("Dados atualizados com sucesso");
        }
      });
    },

    enviar() {
      var error = false;

      for (let item in this.formData) {
        var element = this.formData[item];

        if (!element.destinatario && element.consultas.length > 0) {
          element.error = "Campo Destinatário é Obrigatório";
          error = true;
        } else if (element.consultas.length > 0) {
          var emails = element.destinatario.split(";");

          for (let j = 0; j < emails.length; j++) {
            if (!this.validateEmail(emails[j])) {
              element.error = "Email `" + emails[j] + "` não é válido";
              error = true;
            }
          }
        }
      }

      if (error) {
        this.edAlert("Não foi possível completar o envio. Você deve corrigir os erros apontados acima.", "error");
      } else {
        this.loadingEmailSave = true;

        this.post("empresa/consulta/upload/pagina/" + this.parent.upload_pagina.id + "/enviar", { empresa: this.formData }).then((result) => {
          result = result[0];

          this.loadingEmailSave = false;

          if (result.status == 200) {
            this.edMsg("Emails enviado com sucesso. Você pode acompanhar o status do email atravês do `Histórico de Emails` na página anterior.");
            this.formataData(result);

            this.showEnviarEmail = !this.showEnviarEmail;
            this.formData = {};
            this.tableDataEmail = [];
          }
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// upload-pagina-aso.vue?67b4b79c